export enum SideDrawerMode {
    OFF = "off",
    ASSIGN = "assign",
}
